import { render, staticRenderFns } from "./EntityDataEditCaseModeFields.vue?vue&type=template&id=50bca1eb&scoped=true"
import script from "./EntityDataEditCaseModeFields.vue?vue&type=script&lang=js"
export * from "./EntityDataEditCaseModeFields.vue?vue&type=script&lang=js"
import style0 from "./EntityDataEditCaseModeFields.vue?vue&type=style&index=0&id=50bca1eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bca1eb",
  null
  
)

export default component.exports